import React from 'react';
import SubformDetails from '../../components/subcomponents/subform_details'
import { connect } from 'react-redux';
import Table from '../../components/subcomponents/table'
import FormHeader from '../../components/subcomponents/formheader'
import store  from '../../store'
import Button from '../../components/subcomponents/controls/button';


class MQTTLog extends React.Component {
    clear() {
        store.dispatch({
            type: 'CLEAR_MQTT_LOG'
        });
    }
    render() {
        return (
            <div className="form_wrap mqtt_log">
                <FormHeader title='MQTT_LOG'/>
                <div className="toolbar">
                    <Button name="clear" label="Clear Log" onClick={this.clear.bind(this)}/>
                </div>
                <SubformDetails className="details width_100">
                    <Table name="mqtt_log" table_key={'time'}
                        headers={{
                            time: {label: 'Time', width: '15%'}, 
                            mqtt_message: {label: 'Message',width: '85%'}}}
                        data={this.props.mqtt_log}/>
                </SubformDetails>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mqtt_log: state.systemR.mqtt_log,
        refresh: state.systemR.refresh
    };
}

export default MQTTLog = connect(
    mapStateToProps, null)(
        MQTTLog
);